@if (visibility > 0) {
    <div id="loader-wrapper">
        <div class="la-ball-scale-multiple {{ brand }}">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
}
